import { descriptorOf } from '@tencent/workbench-core';
import { $logger } from '../../../controllers/logger/logger.js';
import { isDynamicLoader, checkLoadState } from '../../../utils/loader-util.js';

/**
 * 方法装饰器，loader如果没下载用默认值
 * @param defaultValue - 方法默认值
 * @param loaderKey  - loader变量名
 * @public
 */
function skipWithDefault(defaultValue, loaderKey = 'loader') {
    return function (target, targetKey, descriptor) {
        if (descriptor === undefined) {
            descriptor = descriptorOf(target, targetKey);
        }
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            const loader = this[loaderKey];
            if (!isDynamicLoader(loader)) {
                $logger.warn(`${String(loaderKey)} is not DynamicLoader`);
                return originalMethod.call(this, ...args);
            }
            if (checkLoadState(loader)) {
                return originalMethod.call(this, ...args);
            }
            return defaultValue;
        };
    };
}

export { skipWithDefault };
//# sourceMappingURL=skip-with-default.js.map
